/* eslint-disable */
import ls from 'local-storage';
import moment from 'moment';
import 'moment/locale/ru';
import '@/js/desktop/components/jsCarousel/jsCarousel';
import Vue from 'vue';

import HotelSearch from '@/js/common/Domain/Service/hotelSearch/HotelSearch';
import TourCriteriaObjectValue from '@/js/common/Domain/ObjectValue/TourCriteria';
import ADVCakeService from '@/js/common/Domain/Service/ADVCake';
import TourProductsRepository from '@/js/common/Domain/Repository/TourProducts';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import ExpiredPopupView from '@/js/desktop/components/expiredPopup/ExpiredPopup';
import SearchRouter from '@/js/common/Domain/Router/SearchRouter';
import ProgressBar from '@/js/desktop/components/progressBar/progress-bar';
import fromRouterHotelHydratorDesktop from '@/js/common/Domain/Hydrator/fromRouterHotelDesktop';
import toLocalStorageTourCriteriaHydrator from '@/js/common/Domain/Hydrator/toLocalStorageTourCriteria';
import Operator from '@/js/common/Domain/Entity/Operator';
import SearchRequestFactory from '@/js/common/Domain/Factory/SearchRequest';
import CheckInDateRangeFactory from '@/js/common/Domain/Factory/CheckInDateRange';
import gaAsync from '@/js/common/Domain/Service/gaAsync';
import tourCriteriaJsonHydrator from '@/js/common/Domain/Hydrator/tourCriteriaJson';
import tourCriteriaHotelService from '@/js/common/Domain/Service/tourCriteriaHotel';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import backboneModelDeepInstanceOf from '@/js/common/Domain/Service/backboneModelDeepInstanceOf';
import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import expandRequestCriteriaDates from '@/js/common/Domain/Service/hotelSearch/services/expandRequestCriteriaDates';
import getStore from '@ve/services/getStore/getStore';
import WarrantedView from '@/js/desktop/components/searchForm/warranted/WarrantedView';
import trackingHotelSearch from '@/js/common/Domain/Service/tracking/trackingHotelSearchData/trackingHotelSearch';

import hotelPageFiltersAdapterStore from '@ve/components/hotel/filters/common/store/hotelPageFiltersAdapterStore';
import HotelPageFilters from '@ve/components/hotel/filters/desktop/HotelPageFilters.vue';
import MealsRepository from '@/js/common/Domain/Repository/Meals';

import RoomInfoDg from '../roomInfoDg/RoomInfoDg';
import tourSearchModel from './service/tourSearchModel';
import datesTabsComponentTemplate from './datesTabsComponentTemplate.html';
import IsAbsentView from '../isAbsent/isAbsent';
import SearchFormHotelView from '../searchForm/searchForm';
import TourProductView from '../TourProduct/TourProduct';

import './tourSearch.scss';

const searchService = new HotelSearch();
const tourProductsCollection = new TourProductsRepository();
const ADVCake = new ADVCakeService('hotel');
let debuouncedMindbox = null;

@propsDecorator({
    model: tourSearchModel(tourProductsCollection),
    collection: tourProductsCollection,
    itemView: TourProductView,
    currentSearchModel: new TourCriteriaObjectValue(),
    progressBarTimer: null,
    parentView: null,
    checkedFilterName: null,
    subview: {
        progressBar: null,
        filterCriteria: null,
    },
    selectedTabDateValuesArray: [],
    changeFilterAsCriteriaDebounce: _.debounce(function (event, model, context) {
        this.changeFilterAsCriteria(event, model, context);
    }, 1000),
})
export default class TourSearchView extends Backbone.Epoxy.View {
    initialize(options) {
        this.datesTabsComponentTemplate = datesTabsComponentTemplate;

        this.init(options);

        this.initEvents();
        this.initModelEvents();
        this.initDOMEvents();
        this.initSubViews();
        this.initVueComponents();
        this.initSubscribes();

        this.searchFormModel.get('checkInDateRange').setNull();
    }

    staticOfferClick(event) {
        const tourProductView = new this.itemView({
            model: new Backbone.Model({
                id: $(event.currentTarget).data('id'),
            }),
        });

        tourProductView.tourSelected({
            currentTarget: $('.HtlTrItemBase', event.currentTarget),
        });
    }


    init(options) {
        const self = this;
        this.searchFormView = new SearchFormHotelView({
            parentView: this,
        });

        this.searchFormModel = this.searchFormView.model;

        this.parentView = options.parentView;

        this.model.view = this;

        new ExpiredPopupView({
            el: '#expiredContainer',
            searchPageViewModel: self.model,
            updateResultCallback() {
                self.formSubmit();
            },
        });

        if (ls.get('isAbsent')) {
            new IsAbsentView({
                el: '.js-tour-was-sold',
                model: this.model,
            });

            this.parentView.dataLayerAnalytics.generateEvent('soldOut', '');
        }
        ls.set('isAbsent', false);
    }

    initEvents() {
        const router = new SearchRouter().getInstance();

        router.on('route', $.proxy(this.changeRouteInit, this));

        this.model.on('change:sortStrategy', this.sortStrategyChanged.bind(this));
        this.model.on('change:loadingState', this.changeLoadingState.bind(this));
        this.currentSearchModel.on('change', this.goSearch.bind(this));

        this.searchFormModel.get('meals').on('change:model', this.changeFilterAsCriteriaDebounce.bind(this));
        this.searchFormModel.get('warranted').on('change:model', this.changeFilterAsCriteria.bind(this));
    }

    changeFilterAsCriteria(event, model, context) {
        if (context && (context.initiator === 'view' || context.initiator === 'filtersPopover')) {
            this.formSubmit({ goToHotelPage: false, openBooking: false });
        }
    }

    initDOMEvents() {
        this.searchFormFix();
        $('.startSearch').on('click', this.formSubmit.bind(this));
    }

    initModelEvents() {
        this.model.on('change:syncTourProducts', $.proxy(this.renderAllFilters, this));
        this.model.on('change:departureCityName', $.proxy(this.changeDepartureCityName, this));

        this.model.get('filterCriteria').on('change', this.updateUrl.bind(this));
    }

    updateUrl() {
        const paramsForRouter = this.getParamsForRouter();
        const router = new SearchRouter().getInstance();
        router.go(`?${$.param(paramsForRouter)}`, { replace: true });
	}

    searchFormFix() {
        const $form = $('.hotel-page-header-form');
        const { top } = $form.offset();
        $(window).on('scroll', function () {
            const scrollTop = $(this).scrollTop();
            if (scrollTop > top) {
                $form.addClass('formFix');
            } else {
                $form.removeClass('formFix');
            }
        });
    }

    changeDepartureCityName() {
        $('.js-departureCityName').html(this.model.get('departureCityName'));
    }

    initSubViews() {
        this.subview.progressBar = new ProgressBar('.js-hotel-progress-bar');
        this.roomInfoDg = new RoomInfoDg();
        this.warrantedFilter = new WarrantedView({
            model: this.searchFormModel.get('warranted'),
            el: $('.js-warranted-checkbox', this.$el),
        });
    }

    initVueComponents() {
        this.initFilters();
    }

    initFilters() {
        const store = hotelPageFiltersAdapterStore({
            tourSearchModel: this.model,
            searchFormModel: this.searchFormModel,
            currentSearchModel: this.currentSearchModel,
            mealsRepository: MealsRepository.repository,
        });

        const filtersComponent = new Vue({
            name: 'HotelPageFilters',
            render: (h) => h(HotelPageFilters),
            store,
        }).$mount('#hotelPageFilters');

        filtersComponent.$on('start-new-search', (date) => {
            const modifiedTourCriteria = this.currentSearchModel.clone();
            modifiedTourCriteria.set('checkInDateRange', new CheckInDateRangeFactory({
                from: date,
                to: date,
            }));
            this.goSearch(modifiedTourCriteria, {
                additionalSearchHotelPage: true,
            });
        });

        filtersComponent.$on('meal-filter-changed', (meals) => {
            const mealsToSet = MealsRepository.repository.filter((meal) => !!~meals.indexOf(meal.get('id')));
            this.searchFormModel.get('meals').set('model', new MealsRepository(mealsToSet), {
                initiator: 'filtersPopover',
            });
        });

        filtersComponent.$on('warranted-filter-changed', (warranted) => {
            this.searchFormModel.get('warranted').set({
                model: warranted,
            }, { initiator: 'view' });
        });
    }

    tabDatesNewSearch() {
        const store = getStore();
        store.dispatch('mapForDatesTabs/startedNewSearch');
    }

    changeRouteInit(type, url) {
        const urlResult = _.isArray(url) ? url[0] : url;
        const hotelInfo = this.parentView.model.get('hotelInfo');
        const additionalData = { setTourCriteria: typeof window.appConfig.defaultTourCriteria !== 'undefined' ? window.appConfig.defaultTourCriteria : {} };

        if (type === 'search' || window.appConfig.noToursFound) {
            this.model.set('beforeToursLoading', false);
            this.changeRouteInit = this.routeChanged;
            this.routeChanged(type, urlResult, additionalData.setTourCriteria);
        } else {
            this.searchFormModel.get('countries').setNull();
            this.searchFormModel.get('resorts').setNull();
            this.searchFormModel.get('hotels').setNull();
            this.searchFormModel.get('checkInDateRange').setNull();
            this.searchFormModel.get('nightRange').setNull();
            this.searchFormModel.get('touristGroup').setNull();
            this.searchFormModel.get('hotelCategories').setNull();
            this.searchFormModel.get('meals').setNull();
            this.searchFormModel.get('priceRange').setNull();

            searchSessionService.generateNewHotelSearchId();

            tourCriteriaHotelService.loadTourCriteriaWithFormDataHotel(additionalData, {
                success: (tourCriteria) => {
                    this.searchFormModel.setTourCriteria(tourCriteria, true);
                    this.parentView.dataLayerAnalytics.initBasicEventsHotel(tourCriteria);
                },
            }, hotelInfo);
        }
    }

    getParamsForRouter() {
        const currentTourCriteria = this.searchFormModel.getTourCriteria();
        const operatorsIds = this.model.get('filterCriteria').get('operators');
        if(operatorsIds.length) { 
            currentTourCriteria.set('operators', new Backbone.Collection(operatorsIds.map((id) => new Operator({ id }))));
        }
        const paramsForRouter = toRouterHotelHydrator({
            tourCriteria: currentTourCriteria,
            identity: this.model.get('selectedIdentity'),
            activeTab: this.parentView.model.get('activeTab'),
            sid: searchSessionService.getSearchId(),
            hsid: searchSessionService.getHotelSearchId(),
        });

        return paramsForRouter;
    }

    routeChanged(type, url, additionalData) {
        let paramsFromUrl = {};
        const hotelInfo = this.parentView.model.get('hotelInfo');

        const loadTourCriteriaWithFormDataForHotel = (params, callback) => {
            tourCriteriaHotelService.loadTourCriteriaWithFormDataHotel(params, {
                success: (tourCriteria) => {
                    this.searchFormModel.setTourCriteria(tourCriteria, true);
                    callback();
                },
                error(tourCriteria) {
                },
            }, hotelInfo);
        };

        if (type === 'search') {
            paramsFromUrl = fromRouterHotelHydratorDesktop(_.isArray(url) ? url[0] : url);
        } else {
            if (additionalData) {
                paramsFromUrl.tourCriteria = additionalData;
            }
            tourCriteriaHotelService.clearTourCriteriaChangedFields();
        }

        if (paramsFromUrl.activeTab) {
            this.parentView.model.set('activeTab', paramsFromUrl.activeTab, { type: 'default' });
        }
        if (paramsFromUrl.identity) {
            this.model.set('selectedIdentity', paramsFromUrl.identity);
        }

        if (paramsFromUrl?.tourCriteria?.operators) {
			this.model.get('filterCriteria').set('operators', paramsFromUrl.tourCriteria.operators.map((id) => +id));
		}

        if (paramsFromUrl.sid) {
            searchSessionService.setSearchId(paramsFromUrl.sid);
        }

        if (paramsFromUrl.hsid) {
            searchSessionService.setHotelSearchId(paramsFromUrl.hsid);
        } else {
            searchSessionService.generateNewHotelSearchId();
        }

        this.model.set('hot', false);
        this.parentView.model.set('hot', false);
        this.model.set('selectedIdentity', false);

        loadTourCriteriaWithFormDataForHotel({ setTourCriteria: paramsFromUrl.tourCriteria }, () => {
            const currentTourCriteria = this.searchFormModel.getTourCriteria();
            this.updateUrl();
            this.currentSearchModel.set(currentTourCriteria.attributes);
            this.model.set('searchData', currentTourCriteria);
        });
    }

    sortStrategyChanged() {
        this.model.set('pageNumber', 1, { silent: true });
        this.collection.reset();
        this.model.get('filteredTourProducts').sort();
        this.model.trigger('change:filteredTourProducts');
        this.scrollToTop();
    }

    clearFilterCriteria() {
        this.model.get('filterCriteria').set('selectedTabDate', 0);
    }

    formSubmit() {
        const self = this;
        const currentTourCriteria = this.searchFormModel.getTourCriteria();

        searchSessionService.changeHotelSearchIdForNewSearch({
            oldSearchCriteria: this.model.get('searchData'),
            newSearchCriteria: currentTourCriteria,
        });
        const paramsForRouter = toRouterHotelHydrator({
            tourCriteria: currentTourCriteria,
            identity: null,
            activeTab: self.parentView.model.get('activeTab'),
            sid: searchSessionService.getSearchId(),
            hsid: searchSessionService.getHotelSearchId(),
        });
        if (currentTourCriteria.isValid() && this.searchFormView.isValid()) {
            if (this.parentView.dataLayerAnalytics) {
                this.parentView.dataLayerAnalytics.clickSearchButtonEvent();
            }
            this.model.set('hot', false);
            this.parentView.model.set('hot', false);
            this.model.set('beforeToursLoading', false);
            this.model.set('selectedIdentity', false);

            const router = new SearchRouter().getInstance();
            const paramsForLocalStorage = toLocalStorageTourCriteriaHydrator(currentTourCriteria);
            const forceChangeTrigger = _.isEqual(this.currentSearchModel.attributes, currentTourCriteria.attributes);

            if ($.cookie) {
                $.cookie('markSearchSource', true, { path: '/', domain: 'all' });
            }

            delete (paramsForLocalStorage.resorts);
            ls.set('tourCriteria', paramsForLocalStorage);

            router.go(`?${$.param(paramsForRouter)}`, { replace: true });

            this.currentSearchModel.set(currentTourCriteria.attributes);

            this.model.set('identity', null);
            this.model.set('searchData', currentTourCriteria);

            //to force search with same params
            if (forceChangeTrigger) {
                this.currentSearchModel.trigger('change', this.currentSearchModel);
            }
            this.model.set('subscribe', '0');
            this.gotoSearchResults();
        }
    }

    minboxTracking() {
        const trackViewHotelData = mindBoxService.trackViewHotelAdapter(this);

        mindBoxService.trackViewHotel({
            idHotel: window.appConfig?.hotelInfo?.id,
            ...trackViewHotelData,
        });
    }

    goSearch(tourCriteria, params) {
        const searchServiceParamsCollection = [];
        const self = this;
        let searchCounter;

        clearInterval(this.progressBarTimer);
        if (tourCriteria.isValid()) {
            if (!params?.additionalSearchHotelPage) {
                this.tabDatesNewSearch();
            }
            searchCounter = this.model.get('searchStartCounter');
            this.model.set('searchStartCounter', ++searchCounter);
            this.parentView.model.set('tourSearchCriteria', tourCriteria, { silent: true });
            this.parentView.model.trigger('change:tourSearchCriteria');
            this.model.set('loadingState', 'loading');
            this.model.set('loadingInProgress', true);

            const searchCriteria = !params?.additionalSearchHotelPage ? expandRequestCriteriaDates(tourCriteria) : tourCriteria;

            searchServiceParamsCollection.push(new SearchRequestFactory(searchCriteria, 'sync'));
            searchServiceParamsCollection.push(new SearchRequestFactory(searchCriteria, 'async'));

            gaAsync(() => {
                ga('send', 'event', 'Request', 'Async', 'from_hotel_page');
            });
            console.log('Async request from hotel page sent');

            const finished = {
                sync: false,
                async: false,
            };

            this.initProgressBar(finished);
            this.clearFilterCriteria();

            const searchServiceRequest = function (searchServiceTourCriterias) {
                searchService.getTourProducts({
                    searchUuid: null,
                    requests: searchServiceTourCriterias,
                    callback: {
                        sync(tourProducts, options) {
                            tourProducts.each((tourProduct) => {
                                tourProduct.initComputeds();
                            });

                            if (tourProducts.length > 0) {
                                ADVCake.updateSearchData(tourCriteria, tourProducts.at(0).get('tour').get('price'));

                                self.model.set('loadingInProgress', false);
                                self.collection.reset();
                                self.model.set('pageNumber', 1, { silent: true });
                                self.model.set('syncTourProducts', tourProducts, { silent: true });
                                self.model.trigger('change:syncTourProducts');
                            } else {
                                self.model.set('syncTourProducts', tourProducts, { silent: true });
                            }

                            finished.sync = true;

                            if (finished.async) {
                                if (self.model.get('loadingInProgress')) {
                                    self.model.set('loadingInProgress', false);
                                    self.collection.reset();
                                    self.model.set('pageNumber', 1, { silent: true });
                                    if (tourProducts && tourProducts.length === 0) {
                                        self.model.set('syncTourProducts', tourProducts);
                                    }
                                }

                                self.model.set('loadingState', 'finished');
                                clearInterval(self.progressBarTimer);
                                self.subview.progressBar.complete();
                            }

                            debuouncedMindbox = _.debounce(
                                () => { setTimeout(self.minboxTracking.bind(self), mindBoxService.mindBoxTrackTimeoutHotelPage); },
                                mindBoxService.mindBoxDebounceTimeHotelPage,
                            );

                            if (!params?.additionalSearchHotelPage) {
                                debuouncedMindbox();
                            }
                        },
                        middleRequest(tourProducts) {
                            const previousTourProducts = self.model.get('syncTourProducts');

                            _.each(tourProducts, (tourProduct) => {
                                tourProduct.initComputeds();
                            });

                            if (previousTourProducts && !previousTourProducts.length && tourProducts && tourProducts.length) {
                                ADVCake.updateSearchData(tourCriteria, previousTourProducts.at(0).get('tour').get('price'));
                            }

                            if (tourProducts.length) {
                                self.model.set('loadingInProgress', false);
                                if (finished.async) {
                                    self.model.set('loadingState', 'finished');
                                    clearInterval(self.progressBarTimer);
                                    self.subview.progressBar.complete();
                                } else {
                                    self.model.set('loadingState', 'asyncLoading');
                                }
                                self.model.trigger('change:syncTourProducts');
                            }
                        },
                        async(tourProducts, options, tourProductsRepository) {
                            const previousTourProducts = self.model.get('syncTourProducts');
                            if (tourProducts && tourProducts.length === 0) {
                                gaAsync(() => {
                                    ga('send', 'event', 'Hotel_Card', 'Hotel_without_prices', document.location.pathname + document.location.hash, { nonInteraction: 1 });
                                });
                            }

                            if (previousTourProducts && !previousTourProducts.length && tourProducts && tourProducts.length) {
                                ADVCake.updateSearchData(tourCriteria, previousTourProducts.at(0).get('tour').get('price'));
                            }

                            if (!previousTourProducts) {
                                self.model.set('syncTourProducts', tourProductsRepository, {
                                    silent: true,
                                });
                            }

                            if (tourProducts && tourProducts.length) {
                                _.each(tourProducts, (tourProduct) => {
                                    tourProduct.initComputeds();
                                });
                                self.model.set('loadingInProgress', false);
                            }

                            if (finished.sync && (!previousTourProducts || previousTourProducts.length === 0)) {
                                self.model.set('loadingInProgress', false);
                                self.model.set('pageNumber', 1, { silent: true });
                            }

                            finished.async = true;
                            console.warn('Закончился асинхронный поиск');
                            self.searchSuccess(tourCriteria, options);

                            if ((tourProducts && tourProducts.length) || !previousTourProducts || !previousTourProducts.length) {
                                self.model.trigger('change:syncTourProducts');
                            }

                            console.log('changed', 'asyncTourProducts', 'loadingState');
                        },
                    },
                    additionalParams: {
                        notClearRepository: params?.additionalSearchHotelPage,
                    },
                });
            };

            self.model.set('asyncTourProducts', null);
            searchServiceRequest(searchServiceParamsCollection);
            this.model.trigger('change:syncTourProducts');
            if (this.parentView.dataLayerAnalytics && this.parentView.dataLayerAnalytics.hsid !== searchSessionService.getHotelSearchId()) {
                this.parentView.dataLayerAnalytics.generateEvent('hsid', searchSessionService.getHotelSearchId());
                this.parentView.dataLayerAnalytics.initBasicEventsHotel(tourCriteria);
                this.parentView.dataLayerAnalytics.hSearchCount = null;
            }

            $('.partialPaymentBanner_forHotelPage')[moment(tourCriteria.get('checkInDateRange').get('from')).diff(moment().startOf('day'), 'days') >= 21 ? 'show' : 'hide']();
        }
    }

    searchSuccess(tourCriteria, options) {
        const minPrice = this.model.get('minPrice');

        if (this.parentView.dataLayerAnalytics && backboneModelDeepInstanceOf({
            model: this.model,
            values: ['minPriceTourProduct', 'tour'],
        }) && this.model.get('searchStartCounter') === 1) {
            const tour = this.model.get('minPriceTourProduct').get('tour');
            const hotelPrices = this.parentView.dataLayerAnalytics.createRangeEvent({
                price: minPrice,
                taxoil: tour.get('oilTaxIsAbsent') ? 999999 : tour.get('oilTax'),
            });
            this.parentView.dataLayerAnalytics.generateEvent('hotelPrices', hotelPrices);
        }

        if (options) {
            trackingHotelSearch(this.model.get('syncTourProducts'), {
                ...options,
                tourCriteria,
                model: this.model,
                searchFormModel: this.searchFormModel,
            });
        }

        this.showSearchFinishedState();
    }

    showSearchFinishedState() {
        if (this.model.get('loadingInProgress')) {
            this.model.set('loadingInProgress', false);
            this.model.set('pageNumber', 1, { silent: true });
        }
        this.model.set('loadingState', 'finished');
        clearInterval(this.progressBarTimer);
        this.subview.progressBar.complete();
    }

    initProgressBar(finished) {
        const self = this;

        this.subview.progressBar.reset();
        this.subview.progressBar.moveToValue(50);

        clearInterval(this.progressBarTimer);

        this.progressBarTimer = setInterval(() => {
            if (finished.sync) {
                const asyncStatus = searchService.getAsyncStatus();
                const { jobsCount } = asyncStatus;
                const jobsSuccess = asyncStatus.jobsCount;
                let jobPercents = 50;

                if (jobsCount && jobsSuccess !== jobsCount) {
                    jobPercents += 50 / jobsCount * (jobsSuccess + 1);
                } else {
                    jobPercents = 100;
                }

                if (jobPercents === 100) {
                    clearInterval(self.progressBarTimer);
                }

                self.subview.progressBar.moveToValue(jobPercents);
            }
        }, 1000);
    }

    initSubscribes() {
        const self = this;

        this.model.on('change:newResultLowerPriceTourProductsFound change:additionalTourProductsFound', function () {
            const cheaperTourProductsCount = this.get('newResultLowerPriceTourProductsFound');
            const additionalTourProductsCount = this.get('additionalTourProductsFound');

            if (cheaperTourProductsCount > 0) {
                self.showAllCheapest();
            } else if (additionalTourProductsCount > 0) {
                self.showAll();
            }
        });
    }

    pageInc() {
        if (this.model.get('pageIncAvaliable')) {
            const store = getStore();
            //to prevent date change to cheapest
            store.dispatch('mapForDatesTabs/selectDateManually');
            this.model.set('pageNumber', this.model.get('pageNumber') + 1);
        }
    }

    showAll() {
        const fullTourProducts = this.model.get('asyncTourProducts');

        this.model.set('pageNumber', 1, { silent: true });
        this.collection.reset();

        this.model.set('syncTourProducts', fullTourProducts);
        this.scrollToTop();

        console.log('Show new async tours click');
        return false;
    }

    showAllCheapest() {
        this.model.set('sortStrategy', 'priceUp');
        this.showAll();
        return false;
    }

    scrollToTop() {
        const currenPosition = $(document).scrollTop();
        const scrollTourProductsListPosition = $('.hotelToursList').offset().top;

        if (currenPosition > scrollTourProductsListPosition) {
            $('html,body').animate({ scrollTop: scrollTourProductsListPosition }, 700);
        }
    }

    gotoSearchResults() {
        $('html,body').animate({
            scrollTop: $('.hotelContent').offset().top - 100,
        }, 500);
    }

    renderAllFilters() {
        const self = this;
        _.forEach(self.model.get('filterCriteria').get('additionalFilters'), (additionalFilter) => {
            self.renderFilters(additionalFilter);
        });
    }

    renderFilters(additionalFilter) {
        const self = this;
        let resultList = {};
        const {filterNamesList} = self.model.get('filterCriteria').get('additionalFilters')[additionalFilter.filterName];
        const allTourProducts = self.model.get('dateFilteredTourProducts') || [];
        const filteredTourProducts = self.model.get('filteredTourProducts') ? self.model.get('filteredTourProducts').models : [];
        const getName = additionalFilter.callback
            || function (model) {
                return model.get('tour').get(additionalFilter.value).name;
            };

        _.each(allTourProducts, (model) => {
            const name = getName(model);
            resultList[name] = {
                name,
                checked: !!~filterNamesList.indexOf(name),
                filterName: additionalFilter.filterName,
                disabled: true,
            };
        });

        _.each(filteredTourProducts, (model) => {
            const name = getName(model);
            if (resultList[name] && resultList[name].disabled) {
                resultList[name].disabled = filterNamesList.length == 0 ? false : filterNamesList.indexOf(name) == -1;
            }
        });
        resultList = _.sortBy(resultList, op => op.name);
        this.model.set(`${additionalFilter.filterName}Title`, filterNamesList.length ? filterNamesList.join(',') : additionalFilter.title);
        self.model.set(additionalFilter.counter, resultList.length);
        if (!additionalFilter.sortTemplate) {
            additionalFilter.getSortTemplate();
        }
        self.$(additionalFilter.id).html(additionalFilter.sortTemplate({filtersList: resultList}));
    }

    changeLoadingState(model, value) {
        const self = this;
        const $similar = $('.js-similar');
        const $partialPaymentBanner = $('.partialPaymentBanner_forHotelPage');
        const tourProducts = this.model.get('syncTourProducts');

        if (value === 'finished' && tourProducts && !tourProducts.length) {
            $similar.removeClass('order3').addClass('order2').find('h3').hide();
            $partialPaymentBanner.addClass('alone');
            compareDataLayerAnalytics(0);
        } else {
            $similar.removeClass('order2').addClass('order3').find('h3').show();
            $partialPaymentBanner.removeClass('alone');
            compareDataLayerAnalytics(1);
        }

        function compareDataLayerAnalytics(hSearchCount) {
            const { dataLayerAnalytics } = self.parentView;
            if (!dataLayerAnalytics) {
                return;
            }
            if (dataLayerAnalytics.hSearchCount !== hSearchCount) {
                dataLayerAnalytics.generateEvent('hSearchCount', hSearchCount);
            }
        }
    }
}
